/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ApiCaller from "~/api/ApiCaller";
import {
  GetPromoToolSitesResponse,
  PostCreateAfnoDetailsRequestBody,
  PostCreateAfnoDetailsResponse,
  PostDeleteAfnoDetailsRequestBody,
  PostDeleteAfnoDetailsResponse,
  PostUpdateAfnoDetailsRequestBody,
  PostUpdateAfnoDetailsResponse,
} from "~/features/promoTools/types";

const PromoToolsApi = {
  getPromoToolsSites: () => ApiCaller.get<GetPromoToolSitesResponse>(`/v1/promotool/promotoolsites`),

  postCreateAfnoDetails: (data: PostCreateAfnoDetailsRequestBody) =>
    ApiCaller.post<PostCreateAfnoDetailsResponse>("/v1/promotool/createdetails", data),

  postUpdateAfnoDetails: (data: PostUpdateAfnoDetailsRequestBody) =>
    ApiCaller.post<PostUpdateAfnoDetailsResponse>("/v1/promotool/updatedetails", data),

  postDeleteAfnoDetails: (data: PostDeleteAfnoDetailsRequestBody) =>
    ApiCaller.post<PostDeleteAfnoDetailsResponse>("/v1/promotool/deletedetails", data),
};

export default PromoToolsApi;
